import { StateCreator } from "zustand";

export interface EntryWizardDraftSlice {
  entryWizardDrafts: Record<string, Record<string, any>>;
  setEntryWizardDraft: (
    contestsEditionId: string,
    draft: Record<string, any>
  ) => void;
  clearEntryWizardDraft: (contestsEditionId: string) => void;
}

export const createEntryWizardDraftSlice: StateCreator<EntryWizardDraftSlice> = (
  set,
  get
) => ({
  entryWizardDrafts: {},
  setEntryWizardDraft: (contestsEditionId, draft) =>
    set(() => ({
      entryWizardDrafts: {
        ...get().entryWizardDrafts,
        [contestsEditionId]: draft,
      },
    })),
  clearEntryWizardDraft: (contestsEditionId) => {
    const nextDrafts = { ...get().entryWizardDrafts };
    delete nextDrafts[contestsEditionId];

    set(() => ({
      entryWizardDrafts: nextDrafts,
    }));
  },
});
